// The "Needs your attention" chips on Home, and the number on the top bar's bell: both are built from the
// same shape of GET /me/pending response (see usePendingCounts), so for the same data they read the same
// way. They are fetched separately, though — Home on every visit, the bell on every in-app navigation
// (the top bar itself only mounts once) — so right after dealing with something elsewhere, the two can be
// briefly out of step until the bell's next navigation. A field that is missing (module off, or this person
// cannot act on it) or zero is left out — a chip is only ever shown for something there is to do.
const plural = (n, word) => `${n} ${word}${n === 1 ? '' : 's'}`;

// Fixed order, so the strip does not reshuffle as counts change.
const CHIPS = [
    { key: 'leaveApprovals', to: '/leaves?tab=team', label: (n) => `${plural(n, 'leave request')} to approve` },
    { key: 'timesheets', to: '/time/approvals', label: (n) => `${plural(n, 'timesheet')} to approve` },
    { key: 'expenses', to: '/tools/expenses?tab=approvals', label: (n) => `${plural(n, 'expense report')} to approve` },
    { key: 'documentsToSign', to: '/documents', label: (n) => `${plural(n, 'document')} to sign` },
    { key: 'tasks', to: '/tasks', label: (n) => `${plural(n, 'task')} for you` },
    { key: 'settlements', to: '/tasks', label: (n) => `${plural(n, 'settlement')} waiting on you` },
    { key: 'payrollPending', to: '/admin/payroll', label: (n) => `Payroll: ${n} ${n === 1 ? 'person' : 'people'} to approve` },
];

/** The chips to show for this pending-counts response, in order, none of them zero. */
export const pendingChips = (pending = {}) =>
    CHIPS.filter(c => (pending[c.key] || 0) > 0).map(c => ({ key: c.key, to: c.to, label: c.label(pending[c.key]) }));

/** Everything added up, for the bell's badge. */
export const pendingTotal = (pending = {}) => CHIPS.reduce((sum, c) => sum + (pending[c.key] || 0), 0);
